function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const nearestDrawer = event.target.closest('header-drawer') ?? event.target.closest('menu-drawer');

  if (nearestDrawer) {
    nearestDrawer.closeMenuDrawer();
  } else {
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');

    // Nuclear option to prevent inert from paralyzing the page
    if (Array.from(document.querySelectorAll('body > *')).map(element => element.getAttribute('inert')).includes('')) {
      unfreezeAll(document.querySelector('*'));
    }

    openDetailsElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }
}

function getExtraneousChildren(parentElement, childElement) {
  if (!childElement || !parentElement.contains(childElement)) {
    return false;
  }

  const parentChain = [];
  let currentElement = childElement;

  while (currentElement !== parentElement) {
    const tagName = currentElement.tagName.toLowerCase();
    const id = currentElement.id ? `#${currentElement.id}` : '';
    const className = currentElement.className ? `.${currentElement.className.trim().replace(/\s+/g, '.')}` : '';

    parentChain.unshift(`${tagName}${id}${className}`);
    currentElement = currentElement.parentElement;
  }

  let finalSelector = [];

  for (let index = 0; index < (parentChain.length - 1); index++) {
    finalSelector.push(`${parentChain[index]} > *:not(${parentChain[index + 1]})`);
  }

  if (finalSelector) {
    return document.querySelectorAll(finalSelector.join(', '));
  } else {
    console.warn("No selectors found between given parent and child elements.");
    return false;
  }
}

function freezeAll(elementArray) {
  if (typeof elementArray !== "object") return;

  elementArray
    .forEach(element => {
      element.setAttribute('inert', '');
    });
}

function unfreezeAll(elementArray) {
  if (typeof elementArray !== "object") return;

  elementArray
    .forEach(element => {
      element.removeAttribute('inert');
    });
}

class CardProduct {
  constructor() {
    this.salePill = "Sale";
    this.priceContainerSelector = ".price";
    this.currencyFormat = new Intl.NumberFormat(
      `${Shopify.locale}-${Shopify.country}`,
      {
        style: 'currency',
        currency: Shopify.currency.active
      }
    );
    this.domParser = new DOMParser();
  }

  blocks() {
    return {
      rating: (reviewsAverage, reviewsCount) => {
        if (!reviewsAverage || reviewsCount < 1) return '<div class="rating"></div>';

        let ratingDecimal = 0;
        let decimal = (reviewsAverage % 1).toFixed(1);

        if (decimal >= 0.3 && decimal <= 0.7) {
          ratingDecimal = 0.5;
        } else if (decimal > 0.7) {
          ratingDecimal = 1;
        }

        return `
          <div class="rating-wrapper">
            <div class="rating" role="img" aria-label="${customInstantSearchConfig.translations.accessibility.star_reviews_info.replace('{{ rating_value }}', reviewsAverage).replace('{{ rating_max }}', 5)}">
              <span aria-hidden="true" class="rating-star color-icon-text" style="--rating: ${Math.floor(reviewsAverage)}; --rating-max: 5; --rating-decimal: ${ratingDecimal};"></span>
            </div>
            <p class="rating-text caption">
              <span aria-hidden="true">${reviewsAverage} / 5</span>
            </p>
            <p class="rating-count caption">
              <span aria-hidden="true">(${reviewsCount})</span>
              <span class="visually-hidden">${reviewsCount} ${customInstantSearchConfig.translations.accessibility.total_reviews}</span>
            </p>
          </div>
        `;
      },
      price: (price, isOnSale = false) => {
        if (!price || customInstantSearchConfig.localization.market.metafields.custom.hide_price_from_product_cards) return '<div class="price"></div>';

        const priceArray = Number.parseFloat(price)?.toFixed(2)?.toString()?.split(".");

        return `<div class="price">
          <div class="price__container">
            <div class="price__regular price__special-formatting">
              <span class="visually-hidden visually-hidden--inline">
                ${customInstantSearchConfig.translations.products.product.price[`${isOnSale ? "sale" : "regular"}_price`]} ${this.currencyFormat.format(price)}
              </span>
              <span class="currency symbol" aria-hidden="true">$</span>
              <span class="price-item price-item--regular" aria-hidden="true">
                <span class="whole-number">${new Intl.NumberFormat().format(priceArray?.[0])}</span>
                <span class="cents">${priceArray?.[1]}</span>
              </span>
            </div>
            <small class="unit-price caption hidden">
              <span class="visually-hidden">Unit price</span>
              <span class="price-item price-item--last">
                <span></span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;per&nbsp;</span>
                <span></span>
              </span>
            </small>
          </div>
        </div>`
      },
      pills: (isOnSale, settings = this.settings) => {
        if (isOnSale) {
          return `
            <span
              id="Badge-${settings?.sectionID}-${settings?.productID}-availability"
              class="badge badge--bottom-left color-accent-1"
            >
              ${customInstantSearchConfig.translations.products.product.on_sale}
            </span>`;
        }

        return '';
      }
    }
  }

  generateCard(settings) {
    const requiredValues = ["title", "url", "productID"];

    if (!requiredValues.every(key => settings?.[key])) return "";

    this.settings = settings;
    //console.log('settings :'+ settings);
    let srcURL = settings?.image?.url ? new URL(settings.image.url) : null;
    let srcset;

    if (srcURL) {
      srcURL.searchParams.append('width', 533);
      srcset = '';

      [165, 360, 533, 720, 940, 1066].forEach(width => {
        let srcURL = new URL(settings.image.url);
        srcURL.searchParams.append('width', width);
        srcset += `${srcURL} ${width}w, `
      });
    }

    // The only attributes we're guaranteed to get from either Shopify Pixels or Instantsearch are:
    //  - ID
    //  - Title
    //  - Product URL
    //  - Image src
    //  
    // These can be 'hardcoded' into the HTML block below because they won't ever need to be replaced with Storefront data
    // The rest are in components so they can be easily generated with Storefront data

    return `
      <div class="card-wrapper product-card-wrapper underline-links-hover" data-shopify-product-id="${settings.productID}">
        <div class="card card--standard card--media" style="--ratio-percent: 100%;">
          <div class="card__inner color-#ffffff gradient ratio" style="--ratio-percent: 100%;">
            <div class="card__media">
              <div class="media media--transparent media--hover-effect">
                ${(() => {
        if (srcURL) {
          return `<img 
                      src="${srcURL}"
                      srcset="${srcset}"
                      alt="${settings.title}" 
                      sizes="(min-width: 1400px) ${(1400 - 130) / 4}px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3)"
                      class="motion-reduce image-resizing--contain" 
                      width="1500" height="833
                    " />`;
        }

        return "";
      })()}
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information ">
              <div class="badge-container">
                <div class="badge-container">
                  ${this.blocks().pills(settings?.tags?.includes(this.salePill))}
                </div>
              </div>
              <h3 class="card__heading h5" id="title--${settings.productID}">
                <a href="${settings.url}" class="full-unstyled-link" aria-labelledby="CardLink--${settings.productID} Badge--${settings.productID}">
                  <span>
                    ${settings.title}
                  </span>
                </a>
              </h3>
              <div class="card-information">
                <span class="caption-large light"></span>

                <!--
                ${this.blocks().rating(parseFloat(settings?.metafields?.yotpo?.reviews_average), settings.metafields?.yotpo?.reviews_count)}
                -->

                <div class="view-for-quote"></div>

                ${this.blocks().price(settings.price, settings?.tags?.includes(this.salePill))}

              </div>
            </div>
          </div>
        </div>
      </div>`;
  }

  async fetchAdditionalProductData(productIds,countryCode = document.body.dataset.market, apiVersion = "2024-07", storefrontAccessToken = '46c44f6ded51c714d5b262190cba8b3c') {

    if (!Array.isArray(productIds) || !productIds?.length) return;

    const response = await fetch(
      `https://pssl-store.myshopify.com/api/${apiVersion}/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken
        },
        body: JSON.stringify({
          
          query: `query test($ids: [ID!]!, $country: CountryCode) 
@inContext(country: $country) {
  nodes(ids: $ids) {
                        ... on Product {
                          id
                          onlineStoreUrl
                          tags
                          reviews_average: metafield(namespace: "yotpo", key: "reviews_average") {
                            value
                          }
                          reviews_count: metafield(namespace: "yotpo", key: "reviews_count") {
                            value
                          }
                          variants(first: 100) {
                            edges {
                              node {
                                id
                                title
                                price {
                                  amount
                                  currencyCode
                                }
                                displays_in_collection: metafield(namespace: "custom", key: "displays_in_collection") {
                                  value
                                },
                                request_type: metafield(namespace: "custom", key: "request_type") {
                                  value
                                },
                                archive_variant: metafield(namespace: "custom", key: "archive_variant") {
                                  value
                                }
                              }
                            }
                          }
                        }
                      }
                    }`,
          variables: {
            "ids": productIds.map(id => `gid://shopify/Product/${id}`),
             country: countryCode
          }
        }),
        signal: AbortSignal.timeout(2000)
      }
    );

    const data = await response.json();
    return data?.data?.nodes;
  }

  async addVariantData(productIds, cardContainers) {
    const additionalProductData = await this.fetchAdditionalProductData(productIds);
    //console.log('Additional Product Data  '+additionalProductData);
    if (!additionalProductData) return;
    cardContainers.forEach(sliderItem => {
      const productID = sliderItem.querySelector('[data-shopify-product-id]').dataset.shopifyProductId;
      const productGID = this.gidHelpers().toGID(productID);
      const currentProductAdditionalData = additionalProductData.find(product => product.id === productGID);

      if (!currentProductAdditionalData) return;

      let productCard = document.querySelector(`[data-shopify-product-id="${productID}"]`);

      // Financing
      // const cheapestAvailableVariantPrice =
      //   parseFloat(
      //     currentProductAdditionalData.variants.edges
      //       .filter(object => object.node.displays_in_collection?.value === "true")
      //       .filter(object => object.node.archive_variant?.value != "true")
      //       .sort((a, b) => parseFloat(a.node.price.amount) - parseFloat(b.node.price.amount))
      //       ?.[0]?.node.price.amount
      //   );
      const variants = currentProductAdditionalData.variants.edges;
      const displayedVariants = variants.filter(
  object => object.node.displays_in_collection?.value === "true"
);

      const activeVariants = displayedVariants.filter(
        object => object.node.archive_variant?.value !== "true"
      );
      
      const sortedVariants = activeVariants.sort(
        (a, b) => parseFloat(a.node.price.amount) - parseFloat(b.node.price.amount)
      );
      let selectedVariant = sortedVariants.find(
        v => parseFloat(v.node.price.amount) > 0
      );
      if (!selectedVariant && sortedVariants.length > 0) {
        selectedVariant = sortedVariants[0];
      }
      const cheapestAvailableVariantPrice = selectedVariant
        ? parseFloat(selectedVariant.node.price.amount)
        : null;
const cheapestUsedAvailableVariant = selectedVariant?.node || selectedVariant;
      

      // Étape 1 : toutes les variantes
      //console.log('Toutes les variantes:', cheapestUsedAvailableVariant);

      if(cheapestAvailableVariantPrice <= 0 ){
           productCard.querySelector('.view-for-quote').innerText = customInstantSearchConfig.translations.products.product.price.view_for_quote;

      }else{
               productCard.querySelector(this.priceContainerSelector).replaceWith(
            ...this.parseElementString(
              this.blocks().price(
                cheapestUsedAvailableVariant.price.amount
              )
            )
          );
                    productCard.querySelector('a').href = `${currentProductAdditionalData.onlineStoreUrl}?variant=${this.gidHelpers().toInt(cheapestUsedAvailableVariant.id, "ProductVariant")}`;

      }
      // if (currentProductAdditionalData.variants.edges.filter(object => object.node.request_type?.value === "Price quote").length) {
      //   productCard.querySelector('.view-for-quote').innerText = customInstantSearchConfig.translations.products.product.price.view_for_quote;

      //   [
      //     financingInfoContainerVisibleText,
      //     financingInfoContainerVisuallyHiddenText,
      //     productCard.querySelector(this.priceContainerSelector)
      //   ].forEach(element => element?.remove());
      //   return;
      // }

      // Reviews
      const reviewsAverage = currentProductAdditionalData?.reviews_average?.value;
      const reviewsCount = currentProductAdditionalData?.reviews_count?.value;
      let ratingContainer = productCard.querySelector('.rating-wrapper');

      if ([reviewsAverage, reviewsCount].some(value => value) && ratingContainer) {
        ratingContainer.replaceWith(
          ...this.parseElementString(
            this.blocks().rating(reviewsAverage, reviewsCount)
          )
        );
      }

      // Sale logic
      if (currentProductAdditionalData?.tags?.includes(this.salePill)) {
        let badgeContainer = productCard.querySelector('.badge-container');
        badgeContainer.innerHTML = "";
        badgeContainer.insertAdjacentHTML(
          'afterbegin',
          this.blocks().pills(true)
        );

        productCard.querySelector(this.priceContainerSelector).replaceWith(
          ...this.parseElementString(
            this.blocks().price(
              cheapestUsedAvailableVariant.price.amount,
              true
            )
          )
        )
      }
    })


  }

  gidHelpers() {
    return {
      toGID: id => {
        return `gid://shopify/Product/${id}`;
      },
      toInt: (gid, object = "Product") => {
        return parseInt(gid.replace(`gid://shopify/${object}/`, ""));
      }
    }
  }

  parseElementString(elementString) {
    let tempContainer = document.createElement('div');
    tempContainer.innerHTML = elementString;

    return Array.from(tempContainer.children);
  }
}
// webit remove
window.solotechCardProduct = new CardProduct();

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.alertElement = this?.querySelector('p[aria-live="polite"]');

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);

      if (this.alertElement) {
        this.alertElement.innerText = '';
        this.alertElement.innerText = this.dataset[`quantity${event.target.name === 'plus' ? "Increased" : "Decreased"}Translation`];
        setTimeout(() => this.alertElement.innerText = '', 5000);
      }
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
      buttonMinus.toggleAttribute('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
      buttonPlus.toggleAttribute('disabled', value >= max);
    }
  }
}
// webit remove
// customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.inertParentElement = this.querySelector('.mobile-facets__disclosure') ?? this;

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.bindEvents();

    window.matchMedia('(min-width: 750px)').addEventListener('change', event => {
      if (event.matches) this.closeMenuDrawer(event, this.mainDetailsToggle);
    })
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('nav button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 749px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        detailsElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      trapFocus(this.mainDetailsToggle, this.querySelector(".mobile-facets__main details:first-child summary"));
    });
    this.mainDetailsToggle.setAttribute('aria-expanded', true);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    freezeAll(
      getExtraneousChildren(
        document.querySelector('html'),
        this.inertParentElement
      )
    );
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.setAttribute('aria-expanded', false);
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    unfreezeAll(
      getExtraneousChildren(
        document.querySelector('html'),
        this.inertParentElement
      )
    );

    setTimeout(() => {
      if (Array.from(document.querySelectorAll('body > *')).map(element => element.getAttribute('inert')).includes('')) {
        unfreezeAll(
          getExtraneousChildren(
            document.querySelector('html'),
            this.inertParentElement
          )
        );
      }
    }, 500);
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    this.header.classList.add('menu-open');
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    this.mainDetailsToggle.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    freezeAll(
      getExtraneousChildren(
        document.querySelector('html'),
        this
      )
    );
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');

    unfreezeAll(
      getExtraneousChildren(
        document.querySelector('html'),
        this
      )
    );

    setTimeout(() => {
      if (Array.from(document.querySelectorAll('body > *')).map(element => element.getAttribute('inert')).includes('')) {
        unfreezeAll(
          getExtraneousChildren(
            document.querySelector('html'),
            this
          )
        );
      }
    }, 500);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.submitEvent = false;
    this.querySelectorAll('[id^="ModalClose-"]').forEach(button => {
      button.addEventListener(
        'click',
        this.hide.bind(this, false)
      );
    })
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    if (opener?.id?.includes("RequestType")) {
      this.eventTimeout = setTimeout(() => this.submitEvent = true, 25000);
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    if (this.submitEvent && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) {
      window?.gtag('event', 'request_quote_submit');
    } else {
      clearTimeout(this?.eventTimeout);
    }

    this.submitEvent = false;
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.ariaBreakpoint = 989;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    this.swapAriaRoles();

    window.matchMedia(`(max-width: ${this.ariaBreakpoint}px)`).onchange = event => this.swapAriaRoles();

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  async attributeChangedCallback(name, oldValue, newValue) {
    // We only care about the "recently-viewed-products" attribute
    if (name !== "recently-viewed-products") return;
    if (newValue !== "true") {
      this.hideSlider();
      return;
    }

    let recentlyViewedProductsString = localStorage.getItem('solotechRecentlyViewedProducts');
    let recentlyViewedProducts;

    try {
      recentlyViewedProducts = JSON.parse(recentlyViewedProductsString);
    } catch (error) { }

    if (!recentlyViewedProducts) {
      this.hideSlider();
      return;
    }

    const filteredProducts = recentlyViewedProducts.filter(
      (obj, index) =>
        recentlyViewedProducts.findIndex((item) => item.product.id === obj.product.id) === index
    );

    if (!filteredProducts.length) {
      this.hideSlider();
      return;
    }

    const cardProductInstance = new CardProduct();
    filteredProducts.forEach((product, index) => {
      let li = document.createElement('li');
      li.id = `Slide-${this.dataset.sectionId}-${index}`;
      li.classList.add("grid__item");

      li.insertAdjacentHTML(
        'afterbegin',
        cardProductInstance.generateCard({
          productID: product.product.id,
          sectionID: this.dataset.sectionId,
          title: product.product.title,
          url: product.product.url,
          price: product?.price?.amount,
          image: {
            url: `https:${product.image.src}`
          }
        })
      );

      this.slider.appendChild(li);
    })

    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();

    cardProductInstance.addVariantData(
      filteredProducts.map(product => product.product.id),
      Array.from(this.sliderItems)
    );
  }

  static get observedAttributes() {
    return ["recently-viewed-products"];
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const withinMediaGallery = this.closest('media-gallery');
    const previousPage = this.currentPage;
    const currentElementIndex = this.currentPage ? this.currentPage - 1 : 0;
    let lastVisibleElementIndex;
    let firstVisibleElementIndex;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    for (let index = 0; index < this.sliderItemsToShow.length; index++) {
      const slide = this.sliderItemsToShow[index];

      if (this.isSlideVisible(slide, -1)) {
        firstVisibleElementIndex = index;
        break;
      }
    }

    for (let index = this.sliderItemsToShow.length - 1; index >= 0; index--) {
      const slide = this.sliderItemsToShow[index];

      if (this.isSlideVisible(slide, -1)) {
        lastVisibleElementIndex = index;
        break;
      }
    }

    this.currentElement = this.sliderItemsToShow[currentElementIndex];

    for (let index = 0; index < this.sliderItemsToShow.length; index++) {
      const allowedTags = ['a', 'button'];
      let cardTrigger;

      if (allowedTags.includes(this.sliderItemsToShow[index]?.tagName?.toLowerCase?.())) {
        cardTrigger = this.sliderItemsToShow[index];
      } else {
        cardTrigger = this.sliderItemsToShow[index]?.querySelector?.(allowedTags.join(', '));
      }

      if (window.innerWidth > this.ariaBreakpoint || withinMediaGallery || this.isMobileSlider()) {
        if (!withinMediaGallery) {
          this.sliderItemsToShow[index].setAttribute(
            'aria-hidden',
            index === currentElementIndex ? false : true
          );
        }

        cardTrigger?.setAttribute?.(
          'tabindex',
          firstVisibleElementIndex <= index && index <= lastVisibleElementIndex ? 0 : -1
        );
      } else {
        cardTrigger?.setAttribute?.('tabindex', 0);
      }
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.currentElement
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  swapAriaRoles() {
    let sliderItemsArray = Array.from(this.sliderItems);
    let slideAriaLabel = this.dataset.slideAriaLabel;
    let role = 'list';
    const slideAriaRoledescription = this.dataset.slideAriaRoledescription;
    const slideRole = this.dataset.slideRole;
    const sliderRole = this.dataset.sliderRole;
    const sliderButtons = Array.from(this.querySelectorAll('button:is([name="previous"], [name="next"])'));
    const isDesktopSlider = this.dataset?.desktopSlider === '';
    const isMobileSlider = this.dataset?.mobileSlider === '';

    if (
      (window.innerWidth < this.ariaBreakpoint && isMobileSlider) ||
      (window.innerWidth > this.ariaBreakpoint && isDesktopSlider)
    ) {
      role = 'aria';
    }

    switch (role) {
      case 'aria':
        this.setAttribute(
          'aria-roledescription',
          this.dataset.sliderComponentAriaRoledescription
        );
        this.slider.setAttribute(
          'aria-label',
          this.dataset.sliderComponentAriaLabel
        );
        this.slider.removeAttribute('role');

        for (let index = 0; index < sliderItemsArray.length; index++) {
          const sliderItem = sliderItemsArray[index];

          sliderItem.setAttribute(
            'aria-roledescription',
            slideAriaRoledescription
          );
          sliderItem.setAttribute(
            'aria-label',
            slideAriaLabel
              .replace('{{ beginning_index }}', (index + 1))
              .replace('{{ ending_index }}', sliderItemsArray.length)
          );
          sliderItem.setAttribute(
            'role',
            slideRole
          );
        }
        sliderButtons.forEach(button => button.classList.remove('hidden'));
        break;
      case 'list':
        this.removeAttribute('aria-roledescription');
        this.slider.removeAttribute('aria-label');
        this.slider.setAttribute('role', sliderRole);

        sliderItemsArray.forEach(sliderItem => {
          ['aria-roledescription', 'aria-label', 'role']
            .forEach(attribute => sliderItem.removeAttribute(attribute))
          sliderItem.setAttribute('aria-hidden', 'false');
        })

        sliderButtons.forEach(button => button.classList.add('hidden'));
        break;
    }
  }

  isMobileSlider() {
    return (window.innerWidth < this.ariaBreakpoint) && this.getAttribute('data-mobile-slider') === ''
  }

  hideSlider() {
    this.slider.closest('section').remove();
    return;
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;
    this.prefersReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.sliderControlWrapper.addEventListener('keydown', event => {
      const currentSlide = this.sliderControlLinksArray.findIndex(link => link.getAttribute('aria-selected') == "true");
      let slideAdvanceAmount;

      switch (event.key) {
        case 'ArrowRight':
          slideAdvanceAmount = 1;
          break;
        case 'ArrowLeft':
          slideAdvanceAmount = -1;
          break;
        case 'Escape':
          this.sliderAutoplayButton.querySelector('[role="tooltip"]').style.display = 'none';
        default:
          break;
      };

      if (slideAdvanceAmount) {
        let slideIndex = currentSlide + slideAdvanceAmount;

        if (slideIndex >= this.sliderItemsToShow.length) slideIndex = 0;
        if (slideIndex < 0) slideIndex = this.sliderItemsToShow.length - 1;

        this.linkToSlide(null, slideIndex);
        this.sliderControlLinksArray[slideIndex].focus();
      }
    });

    this.setSlideVisibility();

    if (
      this.slider.getAttribute('data-autoplay') === 'true' &&
      !this.prefersReducedMotion
    ) this.setAutoPlay();

    if (this.prefersReducedMotion) this.togglePlayButtonState(true);
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;

    this.sliderAutoplayButton.addEventListener('blur', event => {
      this.sliderAutoplayButton.querySelector('[role="tooltip"]').style.display = '';
    });
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.setAttribute('aria-selected', false);
      link.setAttribute('tabindex', -1);
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-selected', true);
    this.sliderControlButtons[this.currentPage - 1].removeAttribute('tabindex');
    this.setSlideVisibility();
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    const tooltip = this.sliderAutoplayButton.querySelector('[role="tooltip"]');

    if (pauseAutoplay) {
      [this.sliderAutoplayButton, this.sliderControlWrapper]
        .forEach(element => element.classList.add('slideshow__autoplay--paused'));
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      tooltip.innerText = window.accessibilityStrings.playSlideshow;
    } else {
      [this.sliderAutoplayButton, this.sliderControlWrapper]
        .forEach(element => element.classList.remove('slideshow__autoplay--paused'));
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      tooltip.innerText = window.accessibilityStrings.pauseSlideshow;
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const interactiveElements = item.querySelectorAll('a, button');

      if (
        (window.innerWidth > this.ariaBreakpoint) ||
        this.isMobileSlider()
      ) {
        if (index === this.currentPage - 1) {
          interactiveElements?.forEach?.(button => {
            button.removeAttribute('tabindex');
          });
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          interactiveElements?.forEach?.(button => {
            button.setAttribute('tabindex', '-1');
          });
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      }
    });
  }

  linkToSlide(event, index) {
    if (event) event.preventDefault();
    if (!event && index === null) return;

    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * ((event?.currentTarget ? this.sliderControlLinksArray.indexOf(event.currentTarget) : index) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {

  constructor() {
    super();
    if (option1Select && !option2Select) {
      const validOption1Values = [...new Set(
        productVariants
          .filter(v => v.archived === false)
          .map(v => v.option1)
      )];

      const selectEl = document.getElementById('option-0-select');

      if (selectEl) {
        // Parcourir chaque <option> du <select>
        Array.from(selectEl.options).forEach(option => {
          if (!validOption1Values.includes(option.value)) {
            option.remove(); // Supprimer si la valeur n'est pas valide
          }
        });

      }
    }


    const body = document.body;
    const select = document.getElementById('option-0-select');
    //console.log('selected :'+select.value);
    
    if (

      (body.classList.contains('price-en-GB') ||
        body.classList.contains('price-en-CA') ||
        body.classList.contains('price-fr-CA')) &&

      select &&
      (select.value === 'New' || select.value === 'Nouveau')
    ) {
      // Sélectionne la 2e option (index 1)


      if (select.options.length > 1) {
        select.selectedIndex = 1;
        select.dispatchEvent(new Event('change')); // Si un événement doit suivre
      }
    }


    if (option2Select) {
      this.updateOption2And3();
    }

    option1Select.addEventListener('change', () => {
      if (option2Select) {
        this.updateOption2And3();
      }
    });
    if (option2Select) {
      option2Select.addEventListener('change', () => {
        if (option3Select) {
          this.updateOption3();
        }
      });
    }

    this.renderFirstLoad();

    this.renderProductInfoJs();

    this.addEventListener('change', this.onVariantChange);

  }

  renderFirstLoad() {
    document.querySelector(".price-wrapper .price").classList.add('hidden');
    document.querySelector(".price-wrapper .view-for-quote").classList.add('hidden');
    let requestedVariantId = this.currentVariant;
    //console.log('requestedVariantId : ' + requestedVariantId);
    if (typeof this.currentVariant === 'undefined' || this.currentVariant === null) {
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromUrl = urlParams.get('variant');
      //console.log('variant url : ' + variantIdFromUrl);
      if (variantIdFromUrl) {
        this.currentVariant = parseInt(variantIdFromUrl, 10); // transforme en nombre si nécessaire
        requestedVariantId = this.currentVariant;
      }
    } else if (this.currentVariant.id) {
      requestedVariantId = this.currentVariant.id;
    }



    const variantId = requestedVariantId;
    const variantScript = document.getElementById('ProductVariantsWebit');
    if (variantScript) {
      const allVariants = JSON.parse(variantScript.textContent);

      const variant = allVariants.find(v => v.id === variantId);
      if (variant) {
        let ActiveFirstChoice = variant.option1;
        const select = document.getElementById('option-0-select');

        if (select) {
          //console.log('select :' + select.value + ActiveFirstChoice);

          // Cherche une option qui a la bonne valeur OU le bon texte
          for (let option of select.options) {
            if (option.value === ActiveFirstChoice || option.text === ActiveFirstChoice) {
              select.value = option.value; // sélectionne l'option

              let ActiveSecondChoice = variant.option2;
              const selectSecond = document.getElementById('option-1-select');

              if (selectSecond) {
                //console.log('select :' + selectSecond.value + ActiveSecondChoice);

                // Cherche une option qui a la bonne valeur OU le bon texte
                for (let optionSecond of selectSecond.options) {
                  if (optionSecond.value === ActiveSecondChoice || option.text === ActiveSecondChoice) {
                    selectSecond.value = optionSecond.value; // sélectionne l'option
                    selectSecond.dispatchEvent(new Event('change')); // déclenche un éventuel changement
                    break;
                  }
                }
              } else {
                select.dispatchEvent(new Event('change')); // déclenche un éventuel changement

              }
              break;
            }
          }
        }

      }

    }
  }

  onVariantChange() {
    if (document.querySelector('.btn-productpopup-request')) {
      document.querySelector('.btn-productpopup-request').classList.add('hidden');
    } else {
      if (document.getElementById("container_availability")) {
        document.getElementById("container_availability").classList.add('hidden');
        document.getElementById("container_quote").classList.add('hidden');
      }
    }

    document.querySelector(".price-wrapper .price").classList.add('hidden');
    document.querySelector(".price-wrapper .view-for-quote").classList.add('hidden');


    this.updateOptions();
    this.updateMasterId();
    // this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {

      this.updatePagesData();

      this.updateMedia();
      this.updateURL();

      this.updateVariantInput();

      this.renderProductInfoJs();

      this.updateShareUrl();


      // this.toggleAddButton(false, '', true);

    }


  }

  toggleAddAction() {
    if (this.currentVariant.request_type == "Availability") {
      document.getElementById("container_availability").classList.remove('hidden');
      document.getElementById("container_quote").classList.add('hidden');
      document.querySelector('.btn-productpopup-request').classList.remove('hidden');

    } else if (this.currentVariant.request_type == "Price quote") {
      document.getElementById("container_availability").classList.add('hidden');
      document.getElementById("container_quote").classList.remove('hidden');
      document.querySelector('.btn-productpopup-request').classList.remove('hidden');

    }

  }

  updatePagesData() {
    const productUrl = `${window.location.pathname}?variant=${this.currentVariant.id}&test=0`;
    fetch(productUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newData = doc.querySelector('.martket_pages_data');
        if (newData) {
          document.querySelector('.martket_pages_data').innerHTML = newData.innerHTML;
        }
      })
      .catch(error => document.querySelector('.martket_pages_data').innerHTML = '');
  }

  updateOptions() {

    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateOption2And3() {
    const selectedOption1 = option1Select.value;
  //console.log('selected option1 : '+selectedOption1);
    // Filtrer variantes disponibles pour option1 choisi
    const filteredVariants = productVariants.filter(v => v.option1 === selectedOption1 && !v.archived);

    // Récupérer les valeurs distinctes d'option2 dispo dans filteredVariants
    const option2Values = [...new Set(filteredVariants.map(v => v.option2))];
//console.log('selected option2 : '+option2Values);

    // Mettre à jour option2 select
    option2Select.innerHTML = '';
    option2Values.forEach(val => {
      const opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      option2Select.appendChild(opt);
    });

    // Auto sélectionner la première option2 dispo
    if (option2Values.length > 0) {
      option2Select.innerHTML = '';
      option2Values.forEach(val => {
        const opt = document.createElement('option');
        opt.value = val;
        opt.textContent = val;
        option2Select.appendChild(opt);
      });
      option2Select.value = option2Values[0];
    } else {
      // Supprimer la valeur actuelle d'option1 du select
      const currentOption1 = selectedOption1;
      const option1Options = Array.from(option1Select.options);

      // Supprime l'option du DOM
      option1Options.forEach((opt, idx) => {
        if (opt.value === currentOption1) {
          option1Select.removeChild(opt);
        }
      });

      // Si d'autres options sont encore disponibles, en sélectionner une nouvelle
      if (option1Select.options.length > 0) {
        option1Select.value = option1Select.options[0].value;
        this.updateOption2And3(); // Relancer la fonction avec la nouvelle valeur
      } else {
        // Plus aucune option 1 disponible — à toi de décider quoi faire ici
        option2Select.innerHTML = '<option disabled>Aucune option disponible</option>';
        option2Select.disabled = true;
      }

    }

    if (option3Select) {
      this.updateOption3();
    }
  }

  updateOption3() {
    const selectedOption1 = option1Select.value;
    const selectedOption2 = option2Select.value;

    // Filtrer variantes dispo pour option1 et option2 choisis
    const filteredVariants = productVariants.filter(v =>
      v.option1 === selectedOption1 && v.option2 === selectedOption2 && !v.archived
    );

    // Récupérer valeurs distinctes option3
    const option3Values = [...new Set(filteredVariants.map(v => v.option3))];

    // Mettre à jour option3 select
    option3Select.innerHTML = '';
    option3Values.forEach(val => {
      const opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      option3Select.appendChild(opt);
    });

    // Auto sélectionner la première option3 dispo
    if (option3Values.length > 0) {
      option3Select.value = option3Values[0];
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}&test=1`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}&test=2`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  formatShopifyPrice(priceInCents, locale = 'en-US') {
    const price = priceInCents / 100;

    // Séparer entier et centimes
    const [whole, cents] = price.toFixed(2).split('.');

    // Formater selon la locale passée (ex : 'fr-CA' => 3 300)
    const formattedWhole = Number(whole).toLocaleString(locale);

    // Créer les éléments HTML
    const span = document.createElement('span');
    span.className = 'price-item price-item--regular';
    span.setAttribute('aria-hidden', 'true');

    const wholeSpan = document.createElement('span');
    wholeSpan.className = 'whole-number';
    wholeSpan.textContent = formattedWhole;

    const centsSpan = document.createElement('span');
    centsSpan.className = 'cents';
    centsSpan.textContent = cents;

    span.appendChild(wholeSpan);
    span.appendChild(centsSpan);

    return span;
  }


  renderProductInfoJs() {
    let requestedVariantId = this.currentVariant;

    if (typeof this.currentVariant === 'undefined' || this.currentVariant === null) {
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromUrl = urlParams.get('variant');

      if (variantIdFromUrl) {
        this.currentVariant = parseInt(variantIdFromUrl, 10); // transforme en nombre si nécessaire
        requestedVariantId = this.currentVariant;
      }
    } else if (this.currentVariant.id) {
      requestedVariantId = this.currentVariant.id;
    }

    const variantId = requestedVariantId;
    const bodyProduct = document.body;
    let locale = 'en-US'; // valeur par défaut

    if (bodyProduct.classList.contains('price-fr-CA')) {
      locale = 'fr-CA';
    } else if (bodyProduct.classList.contains('price-en-CA')) {
      locale = 'en-CA';
    } else if (bodyProduct.classList.contains('price-en-GB')) {
      locale = 'en-UK';
    }

    const variantScript = document.getElementById('ProductVariantsWebit');
    if (variantScript) {
      const allVariants = JSON.parse(variantScript.textContent);

      const variant = allVariants.find(v => v.id === variantId);

      if (variant) {
        //console.log('Variant trouvé :', variant);

        const skuSource = variant.sku;
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        if (skuSource && skuDestination) {
          const span = skuDestination.querySelector('span');
          if (span && span.nextSibling) {
            span.nextSibling.textContent = ' ' + skuSource;
          } else {
            skuDestination.append(' ' + skuSource);
          }
        }

        const d365IdSource = variant.D365 ?? "-";
        const d365IdDestination = document.getElementById(`D365-ID-${this.dataset.section}`);
        if (d365IdSource && d365IdDestination) {
          const span = d365IdDestination.querySelector('span');
          if (span && span.nextSibling) {
            span.nextSibling.textContent = ' ' + d365IdSource;
          } else {
            d365IdDestination.append(' ' + d365IdSource);
          }
        }

        const priceWrapperDestination = document.getElementById(`price-${this.dataset.section}`);
//console.log('prix : '+variant.price + variant.instock);
        if (variant.price && priceWrapperDestination ) {
          const oldPrice = priceWrapperDestination.querySelector('.price-item');
          if (oldPrice) {
            const newPrice = this.formatShopifyPrice(variant.price, locale);
            oldPrice.replaceWith(newPrice);
          } else {
            priceWrapperDestination.appendChild(this.formatShopifyPrice(variant.price, locale));
          }
        }
        let selector = '.price-wrapper .view-for-quote';

        if (variant.price > 0 && variant.available == true) {
          selector = '.price-wrapper .price';
        }



        setTimeout(function () {

          document.querySelectorAll(selector).forEach(element => {
            element.classList.remove('hidden');
          });
        }, 500);



        if (document.getElementById("container_availability")) {
          this.toggleAddAction();
        }


      }
    }



  }

  toggleAddButton(disable = true, text, modifyClass = true) {

    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    let addButton = false;
    if (document.getElementById(`product-form-${this.dataset.section}`)) {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
    }

    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}


const urlParams = new URLSearchParams(window.location.search);
const option1Select = document.getElementById('option-0-select');
const option2Select = document.getElementById('option-1-select');
const option3Select = document.getElementById('option-2-select');


customElements.define('variant-selects', VariantSelects);

/*
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
*/
/* webit remove */
// customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.leaves = {};

    ["hours", "minutes", "seconds"].forEach(unit => {
      this.leaves[unit] = {
        tenths: this.querySelector(`${this.leafSelector(unit)} ${this.placeSelector("tenths")}`),
        hundredths: this.querySelector(`${this.leafSelector(unit)} ${this.placeSelector("hundredths")}`)
      }
    })

    this.translations = {
      hours: {
        singular: this.dataset.hourSingular,
        plural: this.dataset.hourPlural
      },
      minutes: {
        singular: this.dataset.minuteSingular,
        plural: this.dataset.minutePlural
      },
      seconds: {
        singular: this.dataset.secondSingular,
        plural: this.dataset.secondPlural
      }
    }

    this.timer(parseInt(this.dataset.countdownLength));
  }

  timer(seconds) {
    let newSeconds = seconds;

    let countdown = setInterval(() => {
      if (newSeconds <= 0) {
        clearInterval(countdown);
        return;
      };

      this.displayTimeLeft(newSeconds);

      newSeconds -= 1;
    }, 1000);
  }

  displayTimeLeft(seconds) {
    const minute = 60;
    const hour = 3600
    const day = 86400;

    const times = {
      hours: Math.floor((seconds % day) / hour),
      minutes: Math.floor((seconds % day) % hour / minute),
      seconds: seconds % minute
    }

    let screenreaderTextArray = [];

    for (const unit in times) {
      const time = times[unit];

      this.leaves[unit].tenths.textContent = String(this.zeroPad(time)).charAt(0);
      this.leaves[unit].hundredths.textContent = String(this.zeroPad(time)).charAt(1);

      screenreaderTextArray.push(this.translationDecider(unit, times));
    }

    this.querySelector('[data-screenreader-text]').textContent = screenreaderTextArray.join(', ');
  }

  zeroPad(time) {
    return time.toString().padStart(2, '0');
  }

  placeSelector(place) {
    return `[data-place="${place}"]`;
  }

  leafSelector(time) {
    return `[data-leaf="${time}"]`
  }

  translationDecider(unit, times) {
    return `${times[unit]} ${(times[unit] > 1 || times[unit] === 0) ? this.translations[unit].plural : this.translations[unit].singular}`;
  }
}
/* webit remove */
// customElements.define('countdown-timer', CountdownTimer);

/*
if (Shopify.country === "US") {
  document.addEventListener('DOMContentLoaded', event => {
    const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js'];
    const { createQuerySuggestionsPlugin } = window['@algolia/autocomplete-plugin-query-suggestions'];
    const { createRedirectUrlPlugin } = window['@algolia/autocomplete-plugin-redirect-url'];

    const querySuggestionsPlugin = createQuerySuggestionsPlugin({
      searchClient,
      indexName: 'shopify_products_query_suggestions'
    });



    const redirectUrlPlugin = createRedirectUrlPlugin({
      async onRedirect(redirects, { event, navigator, state }) {
        redirectSingleResult({
          state: state,
          event: event,
          redirects: redirects,
          searchClient: searchClient,
          navigator: navigator
        });
      }
    });

    let rootURL = `${customInstantSearchConfig.routes.root_url === "/" ? "" : customInstantSearchConfig.routes.root_url}`;

    
    Array.from(document.querySelectorAll('predictive-search')).forEach((element, index) => {
      element.classList.add('autocomplete-initialized');

      window[`customAutocompleteInstance${index}`] = autocomplete({
        container: element,
        panelContainer: element,
        placeholder: 'Search for products',
        plugins: [redirectUrlPlugin],
        onSubmit({ state, event, setQuery }) {
          setQuery(state.query);
          let form = document.querySelector('form[action="/search"]');
          form.querySelector('input[type="search"]').setAttribute('name', 'shopify_products[query]');
          form.querySelector('input[type="search"]').setAttribute('value', state.query);
          form.submit();
        },
        getSources({ query }) {
          return [
            {
              sourceId: 'products',
              getItemUrl({ item }) {
                let url;

                switch (item.__autocomplete_indexName) {
                  case "shopify_products":
                    url = `${rootURL}products/${item.handle}`;
                    break;
                  case "shopify_collections":
                    url = `${rootURL}${customInstantSearchConfig.routes.collections_url}/${item.handle}`;
                    break;
                  case "shopify_products_query_suggestions":
                    url = `${rootURL}${customInstantSearchConfig.routes.search_url}${new URL(
                      search._createURL(
                        {
                          [search.indexName]: {
                            query: item.query
                          }
                        }
                      )
                    ).search}`;
                    break;
                }

                return url;
              },
              getItems({ query }) {
                return getAlgoliaResults({
                  searchClient,
                  queries: [
                    {
                      indexName: "shopify_products",
                      query,
                      params: {
                        hitsPerPage: 1
                      }
                    },
                    {
                      indexName: "shopify_products_query_suggestions",
                      query,
                      params: {
                        hitsPerPage: 5
                      }
                    },
                    {
                      indexName: collectionsIndex,
                      query,
                      params: {
                        hitsPerPage: 5,
                      }
                    }
                  ],
                  transformResponse({ hits }) {
                    const productsResultsIndex = hits.findIndex(resultsArray => resultsArray?.[0]?.__autocomplete_indexName === "shopify_products");

                    if (productsResultsIndex > -1) hits.splice(productsResultsIndex, 1);

                    const collectionsResultsIndex = hits.findIndex(resultsArray => resultsArray?.[0]?.__autocomplete_indexName === "shopify_collections");

                    if (collectionsResultsIndex > -1) {
                      let collectionResultsCopy = hits[collectionsResultsIndex];

                      hits[collectionsResultsIndex] = collectionResultsCopy.filter(hit => !hit.title.includes("option-group"));
                    }

                    return hits;
                  }
                });
              },
              templates: {
                item({ item, components, html }) {
                  if (!item) return;

                  let url;

                  switch (item.__autocomplete_indexName) {
                    case "shopify_products":
                      url = `${rootURL}products/${item.handle}`;
                      break;
                    case "shopify_collections":
                      url = `${rootURL}${customInstantSearchConfig.routes.collections_url}/${item.handle}`;
                      break;
                    case "shopify_products_query_suggestions":
                      url = `${rootURL}${customInstantSearchConfig.routes.search_url}${new URL(
                        search._createURL(
                          {
                            [search.indexName]: {
                              query: item.query
                            }
                          }
                        )
                      ).search}`;
                      break;
                  }

                  if (!url) return;

                  return html`
                      <a
                        href="${url}"
                        class="predictive-search__item link link--text"
                        aria-label="${item.query}"
                      >
                        ${(() => {
                      if (item?.query) {
                        return components.Highlight({ hit: item, attribute: 'query' });
                      }

                      return item.title
                    })()}
                      </a>
                  `;
                }
              },
              async onSelect({ event, state, setIsOpen, navigator, itemUrl }) {
                setIsOpen(false);
                redirectSingleResult({
                  state: state,
                  event: event,
                  searchClient: searchClient,
                  navigator: navigator,
                  itemUrl: itemUrl
                });
              }
            },
          ];
        },
      })
    });


    document.querySelectorAll('.aa-Input').forEach(input => {
      input.addEventListener('blur', event => {
        [window?.customAutocompleteInstance0, window?.customAutocompleteInstance1].forEach(instance => instance?.setIsOpen(false));
      });
    });
  });
}
*/
async function redirectSingleResult(args) {
  let { state, event, redirects, searchClient, navigator, itemUrl } = args;

  let searchClientParams = [
    {
      indexName: 'shopify_products',
      query: state.query,
      hitsPerPage: 1,
      filters: 'meta.custom.displays_in_collection:true'
    }
  ];

  let item = redirects?.[0];
  itemUrl = itemUrl ? itemUrl : item?.urls?.[0];

  const response = await searchClient?.search(searchClientParams);
  const data = response?.results[0];

  if (!item && data?.nbHits === 1) {
    debugger;
    itemUrl = `/products/${data.hits[0].handle}`;
    item = [
      {
        "sourceId": "products",
        "urls": [
          itemUrl
        ]
      }
    ];
  }

  if (![itemUrl, navigator].every(obj => obj)) return;

  if (event.metaKey || event.ctrlKey) {
    navigator.navigateNewTab({ itemUrl, item, state });
  } else if (event.shiftKey) {
    navigator.navigateNewWindow({ itemUrl, item, state });
  } else {
    navigator.navigate({ itemUrl, item, state });
  }
}

// These scripts need to be transferred to wb-scripts post Dawn 15 update
// -- Start
Element.prototype._addCustomEventListener = function (event, selector, handler) {
  this.addEventListener(
    event,
    function (evt) {
      let targetElement = evt.target;

      while (targetElement != null) {
        if (targetElement.matches(selector)) {
          evt.targetElement = targetElement;
          return handler(evt);
        }
        targetElement = targetElement.parentElement;
      }
    },
    true,
  );
};

// Get cookie
function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

// Set cookie
function setCookie(name, value, minutes = 0) {
  if (minutes) {
    var d = new Date();
    d.setTime(d.getTime() + minutes * 60 * 1000);
    document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
  } else {
    document.cookie = name + '=' + value + ';path=/';
  }
}

// Inject UTM values into Salesforce iframes
function injectUTM(iframe) {
  if (!iframe) return;

  const params = new URLSearchParams(window.location.search);
  const iframeSrc = new URL(iframe.src);

  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((param) => {
    const cookieValue = getCookie(param);

    if (cookieValue) {
      iframeSrc.searchParams.set(param, cookieValue);
    }
  });

  setTimeout(() => {
    iframe.src = iframeSrc.toString();
  }, 50);
}

// Inject params inside Salesforce forms when opening iframe modal
document.querySelector('body')._addCustomEventListener('click', '.btn-productpopup-request', (e) => {
  const iframe = document.querySelector('.pardot-form-iframe');
  
  if (iframe) {
    const productSKU = document.querySelector('.product__sku_info span')?.nextSibling?.textContent;
    const solotechID = document.querySelector('.product__id_info span')?.nextSibling?.textContent;
    const productTitle = document.querySelector('.product__title h1')?.textContent;
    const data = { lastSubmittedUrl: window.location.href, productSKU: productSKU, solotechID: solotechID, productTitle: productTitle };

    iframe.onload = () => {
      iframe.contentWindow.postMessage(data, "https://go.solotech.com");
    }

    injectUTM(iframe);
  }
});

// Inject UTM values as cookies on page load
document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    const params = new URLSearchParams(window.location.search);

    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((param) => {
      const value = params.get(param);

      if(value) {
        setCookie(param, value);
      }
    });

    const pardotContactIframe = document.querySelector('.pardot-contact-iframe');
    if (pardotContactIframe) {
      injectUTM(pardotContactIframe);
    }
  }
});
// -- End